import { useEffect, useState } from 'react'
import bookingsApi from 'services/api/bookings'

import { monthNamesToNumbers } from './constants'

export const useOTABookings = ({
  month,
  year,
  kind,
  parentChain,
  cityToFilter,
  groupToFilter,
  stateToFilter,
  isOtaOnly
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isErred, setIsErred] = useState(false)
  const [hotels, setHotels] = useState()

  useEffect(() => {
    if (month && year) {
      setIsLoading(true)

      bookingsApi
        .otaBookings({
          month: monthNamesToNumbers[month],
          year,
          kind,
          parentChainCode: parentChain,
          city: cityToFilter,
          groupId: groupToFilter,
          state: stateToFilter,
          isOtaOnly
        })
        .then(res => {
          setHotels(res.conversions)
          setIsErred(false)
        })
        .catch(() => {
          setIsErred(true)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [
    month,
    year,
    parentChain,
    kind,
    cityToFilter,
    groupToFilter,
    stateToFilter,
    isOtaOnly
  ])

  return {
    isLoading,
    isErred,
    hotels
  }
}
